import { render, staticRenderFns } from "./YourAccount.vue?vue&type=template&id=e47f8464&scoped=true&"
import script from "./YourAccount.vue?vue&type=script&lang=ts&"
export * from "./YourAccount.vue?vue&type=script&lang=ts&"
import style0 from "./YourAccount.vue?vue&type=style&index=0&id=e47f8464&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47f8464",
  null
  
)

export default component.exports